import ProductIncome from './ProductIncome';

export default ProductIncome;
